import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '150px',
    padding: theme.spacing(2),
  },
  container: {
    display: 'flex',
    columnGap: theme.spacing(2),
  },
}));

export default useStyles;
